/**
 * A search field (ui/SearchField) for a SearchQueryStore: My Texts' and
 * Discover's
 */
import * as preact from "preact";

import SearchQueryStore from "stores/SearchQueryStore";
import SearchField from "ui/SearchField";

interface Props {
  model: SearchQueryStore;
  placeholder?: string;
}

interface State {
  typed: string;
}

class SearchView extends preact.Component<Props, State> {
  private readonly inputRef = preact.createRef<HTMLInputElement>();
  private disposeQueryChange?: () => void;

  state: State = { typed: this.props.model.query.value };

  componentDidMount() {
    // Back to a search: ready to change it
    if (this.state.typed) this.inputRef.current?.focus();
    // Searched for, or cleared (as the language changes), elsewhere too
    this.disposeQueryChange = this.props.model.onQueryChange((query) =>
      this.setState({ typed: query })
    );
  }

  componentWillUnmount() {
    this.disposeQueryChange?.();
  }

  render() {
    const { model, placeholder = "Search" } = this.props;
    return (
      <SearchField
        value={this.state.typed}
        query={model.query.value}
        placeholder={placeholder}
        inputRef={this.inputRef}
        onInput={(typed) => this.setState({ typed })}
        onSearch={(query) => model.setQuery(query)}
      />
    );
  }
}

export default SearchView;
